import React from "react";

const AddressContract = () => {
  return (
    <div className="address-contract">
      <h2>Address Contract</h2>
      <p>Crown CRW address: 0xcEe6450FD8797C10Ec6b6C64784ed4EAB5470e03</p>
      <p>Crown Dex address: 0x20f2238d242888e3b9fe1f7ef7e800f326e3718d - CrownDex LP (CRW-LP)</p>
      <p>Crown Governance Dao address: 0xEa00E8B4b58783fC42De6C82fABc93b656e200E7</p>
      <p>Crown Prediction Market address: 0x96C30869EF529CE8D9126a988c5692F6cA5f41f9</p>
      <p>Crown Bridge address: 0x8B575455CA33eCe8A5EDeEc68A2b4463c6Ff1A85</p>
      <p>CUSD address: 0x16b6eCed5e669EAA934fB4C82F0353ab371420fa</p>
      <p>DEUS address: 0x9a1EE4cC684b75eb847F2CCBDf7DeB26F8f8D6F5</p>
      <p>UserLoans Expanse address: 0x8A6Db722557b8e12AFD3cd8A9fB0C129DBff295C</p>
      
    </div>
  );
};

export default AddressContract;